import { useCallback, useEffect, useState } from 'react'

import { blockSelectionSelector } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/constants'

const useBlockSelection = () => {
  const [selectedBlockId, setSelectedBlockId] = useState(null)

  const selectBlock = useCallback(blockId => setSelectedBlockId(blockId), [])
  const clearSelection = useCallback(() => setSelectedBlockId(null), [])

  useEffect(() => {
    const handleDocumentMouseDown = event => {
      const keepsSelection = event.target instanceof Element && event.target.closest(blockSelectionSelector)

      if (!keepsSelection) clearSelection()
    }

    const handleKeyDown = event => {
      if (event.key === 'Escape') clearSelection()
    }

    document.addEventListener('mousedown', handleDocumentMouseDown)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleDocumentMouseDown)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [clearSelection])

  return { selectedBlockId, selectBlock, clearSelection }
}

export default useBlockSelection
